import z from 'zod'
import { PackageRulesSchema } from '@reward-platform/shared-schemas'
import { CarHirePolicySchema, MonetaryAmountSchema } from '../common'
import { OrderItemTypeSchema } from './order'

export const ReshopOrderParamsSchema = z.object({
  orderId: z.string(),
  bundleRefs: z.array(z.string()).min(0),
})

const ReshopTotalSchema = z.object({
  cash: MonetaryAmountSchema.optional(),
  avios: z.number().optional(),
})
export type ReshopTotal = z.infer<typeof ReshopTotalSchema>

const BaseReshopDifferentialItemSchema = z.object({
  refundPrice: ReshopTotalSchema.optional(),
  oldPrice: ReshopTotalSchema.extend({ priceId: z.string() }).optional(),
  bundleRefs: z.array(z.string()),
})

const HotelReshopDifferentialItemSchema = BaseReshopDifferentialItemSchema.extend({
  type: z.literal(OrderItemTypeSchema.enum.HOTEL),
  packageRules: PackageRulesSchema.optional(),
})

const CarHireReshopDifferentialItemSchema = BaseReshopDifferentialItemSchema.extend({
  type: z.literal(OrderItemTypeSchema.enum.CAR_HIRE),
  locationPolicy: CarHirePolicySchema,
  rentalPolicy: CarHirePolicySchema,
  locationRentalPolicy: CarHirePolicySchema,
})

const FlightReshopDifferentialItemSchema = BaseReshopDifferentialItemSchema.extend({
  type: z.literal(OrderItemTypeSchema.enum.FLIGHT),
})

const ExperienceReshopDifferentialItemSchema = BaseReshopDifferentialItemSchema.extend({
  type: z.literal(OrderItemTypeSchema.enum.EXPERIENCE),
})

const ReshopDifferentialItemSchema = z.discriminatedUnion('type', [
  HotelReshopDifferentialItemSchema,
  CarHireReshopDifferentialItemSchema,
  FlightReshopDifferentialItemSchema,
  ExperienceReshopDifferentialItemSchema,
])

export const ReshopOrderSchema = z.object({
  recommendationId: z.string(),
  bundleId: z.string(),
  total: ReshopTotalSchema,
  differential: z.array(ReshopDifferentialItemSchema),
})
export type ReshopOrder = z.infer<typeof ReshopOrderSchema>
